import Vue from "vue";
const SvEventBus = new Vue();
export default SvEventBus;
